// src/pages/auth/auth.jsx
import React, {useState} from 'react';
import {Hotel, Lock, LogIn, LogOut, User} from 'lucide-react';
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {getManagerName, isLoggedIn, logout} from '../../utils/auth';
import confetti from 'canvas-confetti';
import LoginWindow from "../../components/modal/login/login_windows";

export default function Auth() {
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);

    const handleLogin = (r) => {
        if (r.result) {
            Cookies.set('manager', r.name_login, {expires: 30});
            Cookies.set('manager_id', r.manager_id, {expires: 30});

            // КОНФЕТТИ ПРИ УСПЕШНОМ ВХОДЕ!
            confetti({
                particleCount: 100,
                spread: 70,
                origin: {y: 0.6}
            });

            navigate('/', {replace: true});
        }
    };

    const handleLogout = () => {
        logout();
        navigate('/auth', {replace: true});
    };

    if (isLoggedIn()) {
        return (
            // <div
            //     className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">

            <div
                className="fixed inset-0 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">

                <div className="bg-white rounded-3xl shadow-2xl p-10 max-w-md w-full text-center">
                    <div
                        className="w-24 h-24 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full mx-auto mb-6 flex items-center justify-center">
                        <User size={48} className="text-white"/>
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Добро пожаловать!</h2>
                    <p className="text-xl text-gray-700 mb-8">{getManagerName()}</p>
                    <button
                        onClick={handleLogout}
                        className="w-full py-4 bg-red-600 text-white rounded-2xl font-bold hover:bg-red-700 transition flex items-center justify-center gap-3"
                    >
                        <LogOut size={22}/>
                        Выйти из аккаунта
                    </button>
                </div>
            </div>
        );
    }

    return (
        // <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">
        // <div className="flex-1 flex items-center justify-center p-6">

        <div
            className="fixed inset-0 bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">


            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl p-10 max-w-md w-full text-center">
                <div
                    className="w-28 h-28 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-full mx-auto mb-8 flex items-center justify-center">
                    <Hotel size={64} className="text-white"/>
                </div>
                <h1 className="text-4xl font-extrabold text-gray-900 mb-4">HOTEL MANAGER</h1>
                <p className="text-gray-600 mb-10">Управление мини-отелем</p>

                <button
                    onClick={() => setShowLogin(true)}
                    className="w-full py-5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-2xl font-bold text-lg hover:from-blue-700 hover:to-indigo-700 transition shadow-lg flex items-center justify-center gap-3"
                >
                    <LogIn size={24}/>
                    Войти в систему
                </button>
            </div>

            {/* Модалка логина — снизу, как у тебя везде */}
            {showLogin && (
                <>
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
                         onClick={() => setShowLogin(false)}/>
                    <div className="fixed inset-x-4 bottom-4 z-50 animate-in slide-in-from-bottom duration-300">
                        <div className="bg-white rounded-3xl shadow-2xl p-8">
                            <div className="flex justify-between items-center mb-8">
                                <h2 className="text-2xl font-bold">Вход в систему</h2>
                                <button onClick={() => setShowLogin(false)}
                                        className="p-2 hover:bg-gray-100 rounded-xl">
                                    <Lock size={28} className="text-gray-500"/>
                                </button>
                            </div>
                            {/* Здесь твой LoginWindow, или просто форма */}
                            {/*<LoginWindow _show={showLogin} _setShow={setShowLogin} _login={handleLogin}/>*/}
                            <LoginWindow
                                isOpen={showLogin}
                                onClose={() => setShowLogin(false)}
                                onSuccess={handleLogin}
                            />

                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
